export default {
  setClientGeneral(state, general) {
    state.client.general = general;
  },
  setClientExcursionManagement(state, excursionManagement) {
    state.client.excursionManagement = excursionManagement;
  },
  setClientExcursionManagementVendorsList(state, vendorsList) {
    state.client.excursionManagementVendorsList = vendorsList;
  },
  setClientContentEngine(state, contentEngine) {
    state.client.contentEngine = contentEngine;
  },
  setClientProvider(state, provider) {
    state.client.provider = provider;
  },
  setClientStudentManagement(state, studentManagement) {
    state.client.studentManagement = studentManagement;
  },
  setClientStudentManagementVendorsList(state, vendorsList) {
    state.client.studentManagementVendorsList = vendorsList;
  }
};
